<script>
export default {
  methods: {
    printWindow() {
      window.print();
    }
  }
};
</script>
